import { useLocation, Link } from 'react-router-dom';
import { RoutePath, privatePaths } from 'consts/RoutePath';

export const Header = () => {
	const location = useLocation();
	const isPrivatePath = privatePaths.includes(location.pathname);
	return (
		<>
			<header>
				<div className="header-in">
					<h1 className="logo">
						{isPrivatePath ? (
							<Link to={RoutePath.MY_PAGE}>
								<img src={`${process.env.PUBLIC_URL}/images/logo.svg`} alt="Gakken ID" />
							</Link>
						) : (
							<a href="/">
								<img src={`${process.env.PUBLIC_URL}/images/logo.svg`} alt="Gakken ID" />
							</a>
						)}
					</h1>
				</div>
			</header>
		</>
	);
};
